import React, { useEffect } from 'react';
import styled from 'styled-components';

import { Nights } from '@lt/components/icons-react/userflow';
import { ButtonTs } from '@lt/components';

import type { Nutrition } from '@lt/api/dist/methods/search/types';
import { createWidgetLink } from '../../../utils/url/index';
import {
  useGetWhitelabelDomain,
  useGetBaseQueryParams,
  useGetRedirect,
} from '../../../context/constructorContext';

interface IHotelRoomOffers {
  hotelRoomOffers: Array<Nutrition>;
  currencySymbol: string;
  setSurcharge: React.Dispatch<React.SetStateAction<number>>;
  isSmall: boolean;
}

const HotelRoomOffers = (props: IHotelRoomOffers): JSX.Element => {
  const { setSurcharge, hotelRoomOffers, currencySymbol, isSmall } = props;

  const partnerDomain = useGetWhitelabelDomain();
  const baseQueryParams = useGetBaseQueryParams();
  const redirect = useGetRedirect();

  useEffect(() => {
    setSurcharge(hotelRoomOffers[0].extras.surcharge);
  }, []);

  const addSpacesToPrice = (price: number) => {
    return price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
  };

  const redirectToOffer = (offerLink: string) => {
    const link = createWidgetLink(`${partnerDomain}${offerLink}`, baseQueryParams);
    window.open(link, redirect);
  };

  return (
    <HotelRoomOffersContainer>
      <StyledButton variant="primary" onClick={() => redirectToOffer(hotelRoomOffers[0].link)}>
        <StyledPrice $isBold>
          {addSpacesToPrice(hotelRoomOffers[0].price)} {currencySymbol}
        </StyledPrice>{' '}
        на {hotelRoomOffers[0].nights_count} <StyledNights width={10} $color="#000" />
      </StyledButton>
      {!isSmall &&
        hotelRoomOffers.slice(1).map((hotelRoomOffer) => (
          <StyledHoverableButton
            variant="functional"
            key={hotelRoomOffer.id}
            onClick={() => redirectToOffer(hotelRoomOffer.link)}
          >
            <StyledPrice>
              {addSpacesToPrice(hotelRoomOffer.price)} {currencySymbol}
            </StyledPrice>
            <div>
              на {hotelRoomOffer.nights_count} <StyledNights width={10} $color="4d4d4d" />
            </div>
          </StyledHoverableButton>
        ))}
    </HotelRoomOffersContainer>
  );
};

const HotelRoomOffersContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;

  border-radius: 4px;
`;

const StyledButton = styled(ButtonTs)`
  // повышаем specificity чтобы при многократном использовании компонентов,
  // в разных виджетах на одной странице,
  // первичные стили не перетирали переопределенные
  && {
    height: 38px;
    width: fit-content;
    text-overflow: initial;

    margin: 4px 0;
    padding: 5px 14px;
  }
`;

const StyledHoverableButton = styled(ButtonTs)`
  // повышаем specificity чтобы при многократном использовании компонентов,
  // в разных виджетах на одной странице,
  // первичные стили не перетирали переопределенные
  && {
    margin-left: 16px;
    text-align: left;

    font-size: 12px;

    color: #4d4d4d;
    &:hover {
      color: #007aff;

      svg path {
        fill: #007aff;
      }
    }
  }
`;

const StyledPrice = styled.div<{ $isBold?: boolean }>`
  white-space: nowrap;
  ${({ $isBold }) => $isBold && 'font-weight: 700; display: inline-block;'}
`;

const StyledNights = styled(Nights)<{ $color: string }>`
  path {
    fill: ${({ $color }) => $color};
  }
`;

export default HotelRoomOffers;
